<template>
    <div id="fixedHeader" class="fixed-header">
        <statusBar></statusBar>
        <div v-if="isShowDownAppNav && false" class="downApp">
            <div class="icon-close" @click="onCloseDownAppNav">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
            <div class="tips">{{ domainKey }} {{ $t("footer.ApplicableTo") }} {{ sysPlatform == 'Windows' ? 'Windows' :
                            (sysPlatform == 'ios' ? 'IOS' : 'Android') }}</div>
            <!-- <div class="tips">
                <span>{{ $t("home.DownloadTips") }}</span>
                <span class="money">{{ CurrencyType }}100</span>
            </div> -->
            <div class="btn" @click="onShowDownAppPopup">
                <i class="iconfont icon-shouji"></i>
                <span>{{ $t("home.Download") }}</span>
            </div>
        </div>
        <div class="pages-header">
            <div class="area_left">
                <img class="icon_toggle" src="@/assets/header/icon_toggle.png" alt="" @click="toggleSideBar">
                <!-- <i class="icon_toggle iconfont icon-caidanshouqi" :class="{'sidebarOpened': sidebar.opened}" @click="toggleSideBar"></i> -->
                <div v-if="device !== 'mobile'" class="down_box" @click="onShowDownAppPopup">
                    <div class="down_img">
                        <img src="@/assets/header/icon_window.png" alt="" />
                    </div>
                    <div class="down_info">
                        <div>{{ $t("downApp.ApplicableWindows") }}</div>
                        <div>{{ $t("downApp.ApplicableWindowsTips") }}</div>
                    </div>
                </div>
            </div>
            <div v-if="device !== 'mobile'" class="search_btn" @click.stop="toSearch" >
                <i class="iconfont icon-sousuo"></i>
                <div class="txt"> {{ $t("home.SearchGames") }}</div>
            </div>
            <div class="icon_logo" :class="{'mobile_logo': device == 'mobile'}">
                <img v-if="device == 'mobile'" class="logo" :src="logoUrl2" @click.stop="onPageRefresh" />
                <img v-else class="logo" :src="logoUrl" @click.stop="onPageRefresh" />
            </div>
            <div class="user_action">
                <div></div>
                <div>
                    <div v-if="isLogin && device === 'mobile'" class="user_info">
                        <div class="iconfont icon-shuaxin" :class="{'turning':isRefreshingMoney}" @click.stop="getUserInfo"></div>
                        <div class="user_money">
                            {{ CurrencyType }}{{ allBalance }}
                        </div>
                        <div class="deposit" @click.stop="toDeposit">+</div>
                    </div>
                    <div v-if="isLogin && device !== 'mobile'" class="user_info_pc" @click.stop="toMy">
                        <img class="u_avatar" src="@/assets/person/avatar.png" />
                        <div class="u-info">
                            <div>Hi, {{ userPhone }}</div>
                            <div>ID:{{ userInfo.id }}</div>
                        </div>
                        <img class="u-arrow" src="@/assets/header/icon_arrow.png" />
                    </div>
                    <div v-if="!isLogin" class="user_login">
                        <div class="sign_up" @click="toLogin(1)">{{ $t("login.SignUp") }}</div>
                        <div class="login" @click="toLogin(2)">{{ $t("login.SignIn") }}</div>
                    </div>
                    <div v-if="isLogin" class="Notification" @click.stop="toNotification">
                        <i class="iconfont icon-xiangling"></i>
                        <div v-if="noticeNumber" class="matterNumber">{{ noticeNumber }}</div>
                    </div>
                </div>
            </div>
        </div>
        <logoutPopup ref="logoutPopup"></logoutPopup>
        <!-- <BonusTransferPopup ref="BonusTransferPopup" @confirm="isLogin && getUserInfo()"></BonusTransferPopup> -->
    </div>
</template>

<script>
import { domainKey } from '@/common/http'
import statusBar from '@/components/statusBar'
import logoutPopup from '@/components/logoutPopup'
import { mapState } from 'vuex'
import { getUserInfo } from '@/api/user'
import { isPWA, getPlatform } from '@/utils'
import { Toast } from 'vant'
let savedPwaPrompt888 = null
// import BonusTransferPopup from '@/components/BonusTransferPopup'
export default {
    name: 'Header',
    components: { statusBar, logoutPopup },
    data() {
        return {
            sysPlatform: getPlatform(),
            domainKey,
            pathAct: '',
            isRefreshingMoney: false
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device,
            sidebar: state => state.app.sidebar
        }),
        isLogin() {
            return !!this.$store.getters.token
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        isShowDownAppNav() {
            const isShowDownAppNav = Number(this.$store.state.system.isShowDownAppNav)
            // let downType = this.$store.state.vuex_sysConfig && this.$store.state.vuex_sysConfig.downType || 'apk'
            return isShowDownAppNav === 1 && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android' && getPlatform() !== 'ios'
        },
        noticeNumber() {
            return this.$store.getters.noticeNumber
        }
    },
    created() {
        this.pathAct = this.$route.name
        // if (this.isLogin) getUserInfo()
    },
    mounted() {
        try {
            this.$nextTick(() => {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    // 把事件存起来
                    savedPwaPrompt888 = e
                })
            })
        } catch {
            console.log('error-pwa-不支持？不显示？')
        }
    },
    methods: {
        getUserInfo() {
            this.isRefreshingMoney = true
            getUserInfo().finally(() => {
                this.isRefreshingMoney = false
            })
        },
        onMenuItem(act) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            this.onNavTo({ url: act, type: 'post' })
        },
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar')
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toMy() {
            this.$store.dispatch('user/setIsShowMyPopup', true)
        },
        // onShowDownAppPopup() {
        //     this.$store.dispatch('user/setIsShowDownAppPopup', true)
        // },
        onCloseDownAppNav() {
            this.$store.dispatch('system/setIsShowDownAppNav', 2)
        },
        onShowDownAppPopup() {
            if (this.sysPlatform === 'WebAndroidGame') {
                this.$store.dispatch('user/setIsShowDownAppPopup', true)
            }
            if (this.sysPlatform === 'Windows') {
                if ('serviceWorker' in navigator) {
                    try {
                        savedPwaPrompt888.prompt()
                        savedPwaPrompt888.userChoice.then(choiceResult => {
                            if (choiceResult.outcome === 'accepted') {
                                // this.isShowTipsPopup = true
                                // uni.reLaunch({
                                // 	url: '/pages/index/index'
                                // })
                            } else {
                                console.log('用户拒绝安装PWA--可打印')
                            }
                        })
                    } catch (e) {
                        console.log(e, 'error-pwa-不支持？不显示？')
                        // pwaIconShow.value = false
                    }
                } else {
                    console.log('当前设备不支持')
                }
            }
            // if (this.sysPlatform === 'ios') {
            //     this.$refs.pwaIosPopup.open()
            // }
        },
        toSearch() {
            this.$store.dispatch('user/setIsShowSearchPopup', true)
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        toDeposit() {
            if (this.$route.path.indexOf('/wallet') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toNotification() {
            if (this.$route.path.indexOf('/notification') !== -1) {
                return
            }
            const params = { type: 1 }
            this.onNavTo({ url: '/notification', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
.fixed-header {
    width: 100%;
    position: relative;
    z-index: 98;
    // box-shadow: 0 4px 20px #0006;
    background: #0b2d36;

    .downApp {
        background: linear-gradient(90deg, #f90, #ec0039);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .2rem;
        box-sizing: border-box;
        height: .9rem;
        position: relative;

        &>div.icon-close {
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, .3);
            border-bottom-right-radius: 100%;
            width: .53rem;
            height: .45rem;
            padding-right: .08rem;
            padding-bottom: .1rem;
            box-sizing: border-box;

            &>i {
                font-size: .2rem;
                font-weight: bold;
                color: rgba(255, 255, 255, .8);
            }
        }

        &>div.tips {
            padding-left: .28rem;
            color: #fff;
            font-size: .28rem;

            .money {
                color: #f3df00;
                font-size: .3rem;
                font-weight: 700;
            }
        }

        &>div.btn {
            background: #fff;
            color: #ec0048;
            font-size: .18rem;
            line-height: .5rem;
            padding: .048rem .16rem;
            padding-right: .2rem;
            border-radius: .2rem;
            display: flex;
            align-items: center;

            &>i {
                margin-right: .08rem;
            }
        }
    }

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        height: 1.2rem;
        box-sizing: border-box;
        position: relative;
        padding-left: 300px;

        .area_left{
            position: absolute;
            left: .34rem;
            display: flex;
            align-items: center;
            z-index: 8;

            .icon_toggle{
                color: rgb(174,194,228);
                font-size: .48rem;
                margin-right: .16rem;
                transition: all .3s;
                width: .52rem;
                height: .52rem;
                vertical-align: middle;
                cursor: pointer;

                &.sidebarOpened{
                    transform: rotate(180deg);
                }
            }

            .down_box {
                background: linear-gradient(180deg, rgba(116, 13, 18, 0.96) 0%, rgba(84, 7, 12, 0.98) 100%);
                padding: 4px 6px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                cursor: pointer;
                width: 212px;
                text-align: left;

                .down_img{
                    width: .6rem;
                    height: .6rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 10px;
                    background: rgba(60, 5, 9, 0.92);
                }

                img {
                    width: .4rem;
                    height: .4rem;
                    vertical-align: middle;
                }

                .down_info {
                    font-size: 13px;
                    color: #fff;
                    flex: 1;
                    margin-left: 0.12rem;
                    font-weight: bold;
                    line-height: 18px;

                    &> div:last-child {
                        line-height: 15px;
                        font-size: 12px;
                        color: #d7b87e;
                    }
                }
            }
        }

        .search_btn{
            width: 150px;
            height: 44px;
            border: .02rem solid rgba(224, 179, 86, 0.32);
            border-radius: 10px;
            display: flex;
            align-items: center;
            color: #efd7a8;
            cursor: pointer;
            margin-left: 20px;
            position: absolute;
            left: 320px;
            cursor: pointer;
            z-index: 7;

            .txt {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                // height: 44px;
                // line-height: 42px;
                font-size: 15px;
            }

            .iconfont {
                font-weight: bold;
                height: 44px;
                width: 38px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        &>div.icon_logo {
            position: absolute;
            height: 100%;
            left: calc(50% + 70px);
            transform: translateX(-50%);
            top: 0;
            z-index: 3;
            background: linear-gradient(180deg, rgba(137, 94, 28, 0.96) 0%, rgba(100, 60, 13, 0.98) 100%);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0 0 70px 70px;
            cursor: pointer;
            padding: 0 60px;

            .logo {
                height: .88rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
            }

            &.mobile_logo{
                width: auto !important;
                left: .76rem !important;
                transform: translate(0, -50%) !important;
                background: transparent;
                top: 50% !important;
                padding: 0;
                .logo {
                    height: .84rem !important;
                    filter: drop-shadow(0 0 .08rem rgba(111, 210, 255, .28));
                }
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin: 0 auto;
            // max-width: 1414px;
            min-width: 720px;
            padding-left: 32px;
            padding-right: 32px;
            width: 100%;

            &>div:last-child {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .user_info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-width: 3.15rem;
                height: .76rem;
                padding: .06rem .08rem;
                border-radius: .16rem;
                overflow: hidden;
                box-sizing: border-box;
                background:
                    linear-gradient(180deg, rgba(243, 252, 255, .12) 0%, rgba(243, 252, 255, 0) .18rem),
                    linear-gradient(180deg, rgba(19, 64, 129, .98) 0%, rgba(8, 31, 61, .99) 100%);
                border: 1px solid rgba(255,255,0, 0.28);
                box-shadow: inset 0 1px 0 rgba(232, 248, 255, .1), 0 .06rem .14rem rgba(4, 16, 34, .18);

                .icon-shuaxin {
                    color: #F8F9F9;
                    font-size: .3rem;
                    // width: .45rem;
                    margin-right: .08rem;
                    text-align: center;

                    &.turning {
                        animation: rotateAni 0.2s linear infinite;
                    }

                    @keyframes rotateAni {
                        0% {
                            transform: rotate(0deg);
                        }

                        100% {
                            transform: rotate(-360deg);
                        }
                    }
                }

                .user_account,
                .user_money {
                    color: #FFFFFF;
                    padding: 0 .08rem;
                    border-radius: .2rem;
                    margin-top: 0;
                    font-size: .26rem;
                    font-weight: 700;
                    letter-spacing: .01rem;
                    white-space: nowrap;
                }

                .user_account {
                    color: #b9d8f7;
                }

                .deposit {
                    height: .6rem;
                    border-radius: .17rem;
                    background:
                        linear-gradient(180deg, rgba(243, 252, 255, .22) 0%, rgba(243, 252, 255, .08) 24%, rgba(243, 252, 255, 0) 25%),
                        linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%);
                    color: #f8fcff;
                    line-height: .6rem;
                    font-size: .5rem;
                    margin-left: .08rem;
                    cursor: pointer;
                    width: .66rem;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;

                    &:after {
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        background-image: linear-gradient(90deg, transparent, rgba(255, 255, 255, .5), transparent);
                        background-repeat: no-repeat;
                        animation: bgmove-1badf8a4 linear 2.5s infinite;
                    }

                    @keyframes bgmove-1badf8a4 {
                        0% {
                            background-position: -200px 0
                        }

                        to {
                            background-position: 400px 0
                        }
                    }
                }
            }

            .user_info_pc{
                position: relative;
                cursor: pointer;
                background: linear-gradient(180deg, rgba(111, 11, 16, 0.96) 0%, rgba(79, 6, 10, 0.98) 100%);
                border-radius: 30px;
                padding: 4px 7px 4px 4px;
                height: 48px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                gap: 0;

                .u_avatar{
                    border-radius: 25px;
                    margin-right: 8px;
                    height: 100%;
                    background: rgba(255, 240, 184, 0.18);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 40px;
                    border-radius: 25px;
                    object-fit: contain;
                    vertical-align: middle;
                }
                .u-info{
                    line-height: 1.02;
                    font-size: 16px;
                    color: #fff;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    min-width: 0;

                    & > div:first-child{
                        font-weight: 700;
                        white-space: nowrap;
                    }
                    & > div:last-child{
                        color: #e7c789;
                        font-size: 13px;
                        margin-top: 2px;
                        white-space: nowrap;
                    }
                }
                .u-arrow{
                    transform: rotate(-90deg);
                    width: 12px;
                    margin: 0 3px 0 6px;
                    border-style: none;
                    height: auto;
                    flex: none;
                }
            }

            .Notification {
                width: 46px;
                height: 46px;
                background: linear-gradient(180deg, rgba(111, 11, 16, 0.96) 0%, rgba(79, 6, 10, 0.98) 100%);
                border-radius: 23px;
                margin: 0 0 0 7px;
                cursor: pointer;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;

                &:hover {
                    background: rgba(255, 232, 166, 0.14);
                }

                &>i {
                    font-size: .36rem;
                    color: #FFFFFF;
                }

                .matterNumber{
                    position: absolute;
                    height: .36rem;
                    width: .36rem;
                    border-radius: 50px;
                    background: #ff0000;
                    color: #fff;
                    font-size: .26rem;
                    top:-.1rem;
                    right: -.1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .user_login {
                font-size: .26rem;
                height: .7rem;
                line-height: .7rem;
                display: flex;
                align-items: center;

                .login {
                    color: #ffffff;
                    cursor: pointer;
                    text-align: center;
                    padding: 0 .18rem;
                    border-radius: .1rem;
                    margin-right: .02rem;
                    border: .01rem solid rgba(224, 179, 86, 0.26);
                    background: linear-gradient(180deg, rgba(111, 11, 16, 0.96) 0%, rgba(79, 6, 10, 0.98) 100%);
                }

                .sign_up {
                    color: #6a1e07;
                    cursor: pointer;
                    text-align: center;
                    border-radius: .15rem;
                    padding: 0 .18rem;
                    background: linear-gradient(180deg, #ffe8a6 0%, #d59b32 100%);
                    margin-right: .12rem;
                    font-weight: bold;

                }
            }
        }
    }
}

html[data-device-nodesktop="1"] {
    .fixed-header {
        z-index: 100;

        .downApp {
            display: none;
        }
    }
}
.fixed-header {
    background:
        radial-gradient(circle at 16% 0, rgba(95, 224, 255, .18) 0, rgba(95, 224, 255, 0) 22%),
        linear-gradient(180deg, rgba(207, 245, 255, .05) 0, rgba(207, 245, 255, 0) .14rem),
        linear-gradient(90deg, #16467c 0%, #123865 34%, #0d294c 68%, #091a32 100%);
    box-shadow: inset 0 -1px 0 rgba(5, 18, 42, .96), 0 .08rem .22rem rgba(4, 16, 34, .26);

    .pages-header {
        background:
            radial-gradient(circle at 18% 0, rgba(95, 224, 255, .12) 0, rgba(95, 224, 255, 0) 18%),
            linear-gradient(90deg, rgba(255, 255, 255, .03) 0, rgba(255, 255, 255, 0) 18%, rgba(255, 255, 255, 0) 82%, rgba(255, 255, 255, .03) 100%),
            linear-gradient(90deg, rgba(22, 78, 140, .98) 0%, rgba(16, 61, 109, .98) 30%, rgba(11, 43, 79, .99) 64%, rgba(7, 25, 49, .99) 100%);
        border-top: 1px solid rgba(108, 210, 255, .16);
        border-bottom: 1px solid rgba(5, 18, 42, .96);
    }

    .pages-header .area_left .icon_toggle {
        padding: .08rem;
        background: linear-gradient(180deg, #67dcff 0%, #2faaff 58%, #176ff2 100%);
        border-radius: 50%;
        box-shadow: inset 0 1px 0 rgba(223, 247, 255, .44), 0 .05rem .12rem rgba(7, 26, 58, .24);
    }

    .pages-header .area_left .down_box,
    .pages-header .search_btn,
    .pages-header .user_info,
    .pages-header .user_login .login {
        background: linear-gradient(180deg, rgba(18, 71, 132, .98) 0%, rgba(9, 39, 78, .99) 100%);
        border: 1px solid rgba(97, 190, 255, .32);
        box-shadow: inset 0 1px 0 rgba(212, 244, 255, .09), 0 .06rem .14rem rgba(5, 18, 40, .18);
    }

    .pages-header .area_left .down_box .down_img,
    .pages-header .user_info_pc .u_avatar {
        background: linear-gradient(180deg, #08172e 0%, #040d1e 100%);
    }

    .pages-header .area_left .down_box .down_info,
    .pages-header .search_btn,
    .pages-header .user_info_pc .u-info > div:first-child,
    .pages-header .user_info .user_money {
        color: #f5fbff;
    }

    .pages-header .area_left .down_box .down_info > div:last-child,
    .pages-header .search_btn .txt,
    .pages-header .user_info_pc .u-info > div:last-child {
        color: #93badb;
    }

    .pages-header > div.icon_logo {
        background: transparent;
        border: none;
        box-shadow: none;
    }

    .pages-header .search_btn {
        color: #edf8ff;
    }

    .pages-header .search_btn .iconfont,
    .pages-header .user_info .icon-shuaxin {
        color: #edf8ff;
    }

    .pages-header .user_info .deposit,
    .pages-header .user_login .sign_up {
        color: #f5fbff;
        background:$bg-btn-color;
        box-shadow: inset 0 1px 0 rgba(223, 246, 255, .28), 0 0 .14rem rgba(53, 186, 255, .22);
    }

    .pages-header .user_login .login {
        color: #ffffff;
        background: linear-gradient(180deg, rgba(25, 117, 205, .96) 0%, rgba(12, 56, 110, .99) 100%);
        box-shadow: inset 0 1px 0 rgba(220, 245, 255, .12), inset 0 -.05rem .12rem rgba(5, 18, 40, .24);
    }

    .pages-header .user_info_pc,
    .pages-header .Notification {
        background:
            linear-gradient(180deg, rgba(223, 246, 255, .08) 0%, rgba(223, 246, 255, 0) .14rem),
            linear-gradient(180deg, #13518f 0%, #0a2b56 100%);
        border: 1px solid rgba(101, 196, 255, .32);
        box-shadow: inset 0 1px 0 rgba(223, 246, 255, .08), 0 .06rem .12rem rgba(5, 18, 40, .16);
    }

    .pages-header .Notification > i {
        color: #f5fbff;
    }

    .pages-header .user_info_pc .u-info > div:first-child,
    .pages-header .user_info_pc .u-info > div:last-child,
    .pages-header .user_info_pc .u-arrow {
        color: #f5fbff;
    }

    .pages-header .user_info_pc .u-info > div:last-child {
        color: #93badb;
    }

    .pages-header .Notification:hover,
    .pages-header .search_btn:hover,
    .pages-header .area_left .down_box:hover,
    .pages-header .user_info_pc:hover {
        filter: brightness(1.05);
    }
}

html[data-device-nodesktop="0"] {
    .fixed-header {
        .pages-header {
            min-height: 1.04rem;
            padding: .12rem .2rem;
            padding-left: 4.48rem;
            gap: .14rem;
            box-sizing: border-box;
        }

        .pages-header .area_left {
            left: .12rem;
            gap: .1rem;
            max-width: 4.08rem;
        }

        .pages-header .area_left .icon_toggle {
            width: .44rem;
            height: .44rem;
            padding: .07rem;
            flex: none;
        }

        .pages-header .area_left .down_box {
            height: .58rem;
            width: 3.62rem;
            padding: .05rem .16rem .05rem .1rem;
            border-radius: .14rem;
            gap: .08rem;
            box-sizing: border-box;
        }

        .pages-header .area_left .down_box .down_img {
            width: .42rem;
            height: .42rem;
            border-radius: .12rem;
            flex: none;
        }

        .pages-header .area_left .down_box .down_img img {
            width: .24rem;
            height: .24rem;
        }

        .pages-header .area_left .down_box .down_info {
            line-height: .96;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .pages-header .area_left .down_box .down_info > div:first-child {
            font-size: .085rem;
            font-weight: 700;
            line-height: .96;
            letter-spacing: .002rem;
        }

        .pages-header .area_left .down_box .down_info > div:last-child {
            margin-top: .015rem;
            font-size: .065rem;
            line-height: .96;
            letter-spacing: .001rem;
        }

        .pages-header .search_btn {
            width: 2.18rem;
            height: .62rem;
            border-radius: .14rem;
            padding: 0 .18rem;
            margin-left: 0;
            flex: none;
            justify-content: flex-start;
            gap: .1rem;
            box-sizing: border-box;
        }

        .pages-header .search_btn .iconfont {
            font-size: .22rem;
            flex: none;
        }

        .pages-header .search_btn .txt {
            font-size: .14rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .pages-header > div.icon_logo {
            width: 3.9rem;
            height: .74rem;
            left: 50%;
            transform: translateX(-50%);
            top: .04rem;
            border-radius: 0;
            overflow: hidden;
        }

        .pages-header > div.icon_logo .logo {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            filter: drop-shadow(0 2px 4px rgba(63, 9, 3, .45));
        }

        .pages-header .user_action {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            min-width: 0;
        }

        .pages-header .user_action > div:last-child {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: .1rem;
            min-width: 0;
        }

        .pages-header .user_info_pc {
            height: .62rem;
            padding: .04rem .08rem .04rem .05rem;
            border-radius: .14rem;
            box-sizing: border-box;
        }

        .pages-header .user_info_pc .u_avatar {
            width: .5rem;
            min-width: .5rem;
            height: .5rem;
            margin-right: .08rem;
            border-radius: 50%;
        }

        .pages-header .user_info_pc .u-info {
            font-size: .14rem;
            white-space: nowrap;
            min-width: 1.16rem;
            justify-content: center;
        }

        .pages-header .user_info_pc .u-info > div:last-child {
            margin-top: .03rem;
            font-size: .1rem;
        }

        .pages-header .user_info_pc .u-arrow {
            width: .12rem;
            margin: 0 .03rem 0 .05rem;
            opacity: .95;
            filter: brightness(2.4) saturate(.15);
        }

        .pages-header .Notification {
            width: .58rem;
            height: .58rem;
            min-width: .58rem;
            border-radius: 50%;
            margin: 0;
        }

        .pages-header .Notification > i {
            font-size: .22rem;
        }

        .pages-header .user_login {
            height: .62rem;
            line-height: .62rem;
            gap: .1rem;
        }

        .pages-header .user_login .sign_up,
        .pages-header .user_login .login {
            height: .62rem;
            line-height: .62rem;
            min-width: 1.34rem;
            padding: 0 .2rem;
            border-radius: .14rem;
            font-size: .23rem;
            font-weight: 700;
            margin-right: 0;
            box-sizing: border-box;
        }

        .pages-header .user_login .login {
            min-width: 1.48rem;
        }
    }
}

.fixed-header {
    background:
        radial-gradient(circle at 12% 0, rgba(98, 226, 255, .16) 0, rgba(98, 226, 255, 0) 22%),
        radial-gradient(circle at 88% 0, rgba(48, 139, 255, .12) 0, rgba(48, 139, 255, 0) 24%),
        linear-gradient(90deg, #0e2e59 0%, #123f75 34%, #10345f 68%, #0a223f 100%);
    border-bottom: 1px solid rgba(110, 203, 255, .18);
    box-shadow: inset 0 1px 0 rgba(203, 244, 255, .1);
}

.pages-header {
    background: transparent;
}

.pages-header .area_left .icon_toggle {
    background:
        linear-gradient(180deg, rgba(223, 247, 255, .18) 0%, rgba(223, 247, 255, .04) 22%, rgba(223, 247, 255, 0) 23%),
        linear-gradient(180deg, #2ab7ff 0%, #167cf7 100%);
    box-shadow: inset 0 1px 0 rgba(237, 251, 255, .28), 0 .06rem .12rem rgba(4, 16, 34, .22);
}

.pages-header .area_left .down_box {
    background:
        radial-gradient(circle at 16% 0, rgba(88, 213, 255, .2) 0, rgba(88, 213, 255, 0) 28%),
        linear-gradient(180deg, rgba(223, 247, 255, .08) 0%, rgba(223, 247, 255, 0) .14rem),
        linear-gradient(180deg, rgba(15, 55, 103, .98) 0%, rgba(10, 37, 72, .99) 100%);
    border: 1px solid rgba(96, 196, 255, .24);
    box-shadow: inset 0 1px 0 rgba(223, 247, 255, .1), 0 .06rem .14rem rgba(4, 16, 34, .18);
}

.pages-header .area_left .down_box .down_img {
    background: linear-gradient(180deg, #050e1a 0%, #02070f 100%);
    border: 1px solid rgba(133, 215, 255, .12);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .04);
}

.pages-header .area_left .down_box .down_info > div:first-child {
    color: #eef9ff;
}

.pages-header .area_left .down_box .down_info > div:last-child {
    color: #94c2e6;
}

.pages-header .search_btn {
    background:
        radial-gradient(circle at 12% 0, rgba(123, 126, 255, .14) 0, rgba(123, 126, 255, 0) 30%),
        linear-gradient(180deg, rgba(232, 248, 255, .08) 0%, rgba(232, 248, 255, 0) .14rem),
        linear-gradient(180deg, rgba(12, 50, 98, .98) 0%, rgba(7, 27, 56, .99) 100%);
    border: 1px solid rgba(255,255,0, .34);
    box-shadow:
        inset 0 1px 0 rgba(232, 248, 255, .08),
        0 0 .16rem rgba(80, 176, 255, .1),
        0 .04rem .1rem rgba(4, 16, 34, .16);
}

.pages-header > div.icon_logo {
    background:
        radial-gradient(circle at 50% 0, rgba(79, 207, 255, .14) 0, rgba(79, 207, 255, 0) 36%),
        linear-gradient(180deg, rgba(223, 247, 255, .06) 0%, rgba(223, 247, 255, 0) .16rem),
        linear-gradient(180deg, rgba(16, 63, 119, .95) 0%, rgba(9, 33, 66, .98) 100%);
    border-radius: 0 0 .34rem .34rem;
    box-shadow: inset 0 1px 0 rgba(223, 247, 255, .08), 0 .08rem .16rem rgba(4, 16, 34, .12);
}

.pages-header .user_login .sign_up {
    background:
        radial-gradient(circle at 18% 0, rgba(136, 236, 255, .26) 0, rgba(136, 236, 255, 0) 32%),
        linear-gradient(180deg, rgba(240, 252, 255, .24) 0%, rgba(240, 252, 255, .08) 20%, rgba(240, 252, 255, 0) 21%),
        linear-gradient(90deg, rgba(73, 226, 255, 1) 0%, rgba(43, 184, 255, .99) 42%, rgba(21, 109, 235, .96) 100%);
    border: 1px solid rgba(131, 225, 255, .52);
    box-shadow:
        inset 0 1px 0 rgba(240, 252, 255, .28),
        0 0 .2rem rgba(55, 189, 255, .2),
        0 .06rem .14rem rgba(4, 16, 34, .14);
}

.pages-header .user_login .login,
.pages-header .user_info_pc,
.pages-header .Notification {
    background:
        radial-gradient(circle at 16% 0, rgba(96, 214, 255, .15) 0, rgba(96, 214, 255, 0) 28%),
        linear-gradient(180deg, rgba(228, 248, 255, .08) 0%, rgba(228, 248, 255, 0) .14rem),
        linear-gradient(180deg, rgba(17, 63, 121, .98) 0%, rgba(9, 30, 61, .99) 100%);
    border: 1px solid rgba(104, 204, 255, .24);
    box-shadow:
        inset 0 1px 0 rgba(228, 248, 255, .08),
        0 .05rem .12rem rgba(4, 16, 34, .16);
}

.pages-header .user_login .login:hover,
.pages-header .user_info_pc:hover,
.pages-header .Notification:hover {
    border-color: rgba(129, 221, 255, .34);
    box-shadow:
        inset 0 1px 0 rgba(228, 248, 255, .1),
        0 0 .18rem rgba(47, 170, 255, .12),
        0 .05rem .12rem rgba(4, 16, 34, .16);
}

.pages-header .Notification > i,
.pages-header .user_info_pc .u-info > div:first-child,
.pages-header .user_info_pc .u-arrow {
    color: #f5fbff;
}

.pages-header .user_info_pc .u-info > div:last-child,
.pages-header .search_btn .txt {
    color: #a8cde9;
}

.pages-header .user_login .login {
    color: #f3fbff;
}

.fixed-header .pages-header .user_info_pc,
.fixed-header .pages-header .Notification {
    background:
        radial-gradient(circle at 16% 0, rgba(96, 214, 255, .15) 0, rgba(96, 214, 255, 0) 28%),
        linear-gradient(180deg, rgba(228, 248, 255, .08) 0%, rgba(228, 248, 255, 0) .14rem),
        linear-gradient(180deg, rgba(17, 63, 121, .98) 0%, rgba(9, 30, 61, .99) 100%) !important;
    border: 1px solid rgba(104, 204, 255, .24) !important;
    box-shadow:
        inset 0 1px 0 rgba(228, 248, 255, .08),
        0 .05rem .12rem rgba(4, 16, 34, .16) !important;
}

.fixed-header .pages-header .user_info_pc .u-info > div:first-child,
.fixed-header .pages-header .Notification > i,
.fixed-header .pages-header .user_info_pc .u-arrow {
    color: #f5fbff !important;
}

.fixed-header .pages-header .user_info_pc .u-info > div:last-child {
    color: #a8cde9 !important;
}

@media screen and (max-width: 767px) {
    .pages-header .area_left .icon_toggle {
        width: .56rem !important;
        height: .56rem !important;
        padding: .1rem !important;
        box-sizing: border-box;
    }

    .pages-header {
        padding-left: 0 !important;
        justify-content: space-between;
    }

    .pages-header .area_left {
        left: .12rem !important;
        z-index: 4;
    }

    .pages-header .user_action {
        width: 100%;
        padding-left: 2.18rem;
        box-sizing: border-box;
    }

    .pages-header .user_action > div:first-child {
        display: none;
    }

    .pages-header .user_action > div:last-child {
        width: 100%;
        justify-content: flex-end;
        gap: .1rem;
        padding-right: 0;
        box-sizing: border-box;
    }

    .pages-header .user_info {
        min-width: 0 !important;
        width: auto !important;
        max-width: calc(100vw - 2.26rem) !important;
        height: .64rem !important;
        padding: .05rem .07rem .05rem .1rem !important;
        border-radius: .16rem !important;
        background:
            radial-gradient(circle at 16% 0, rgba(96, 214, 255, .15) 0, rgba(96, 214, 255, 0) 28%),
            linear-gradient(180deg, rgba(228, 248, 255, .08) 0%, rgba(228, 248, 255, 0) .14rem),
            linear-gradient(180deg, rgba(17, 63, 121, .98) 0%, rgba(9, 30, 61, .99) 100%) !important;
        border: 1px solid rgba(104, 204, 255, .24) !important;
        box-shadow:
            inset 0 1px 0 rgba(228, 248, 255, .08),
            0 .05rem .12rem rgba(4, 16, 34, .16) !important;
    }

    .pages-header .user_info .user_money {
        flex: 1;
        min-width: 0;
        margin-top: 0 !important;
        padding: 0 .01rem !important;
        color: #f5fbff !important;
        font-size: .23rem !important;
        line-height: .54rem !important;
        font-weight: 700 !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background: transparent !important;
    }

    .pages-header .user_info .deposit {
        width: .54rem !important;
        min-width: .54rem !important;
        height: .54rem !important;
        line-height: .43rem !important;
        margin-left: .05rem !important;
        border-radius: .16rem !important;
        font-size: .38rem !important;
        background:
            linear-gradient(180deg, rgba(243, 252, 255, .22) 0%, rgba(243, 252, 255, .08) 24%, rgba(243, 252, 255, 0) 25%),
            linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%) !important;
        color: #f8fcff !important;
        border: 1px solid rgba(131, 225, 255, .42) !important;
        box-shadow: inset 0 1px 0 rgba(243, 252, 255, .24), 0 .05rem .12rem rgba(4, 16, 34, .14) !important;
    }

    .pages-header .Notification {
        width: .6rem !important;
        height: .62rem !important;
        min-width: .6rem !important;
    }

    .pages-header .Notification > i {
        font-size: .24rem !important;
    }
}

.pages-header .user_wrap .user_info,
.pages-header .area_right .user_info {
    background:
        linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
    border-color: rgba(255,255,0, .28) !important;
    box-shadow: inset 0 1px 0 rgba(232, 248, 255, .08), 0 .08rem .18rem rgba(4, 16, 34, .16) !important;
}

.pages-header .user_wrap .Notification,
.pages-header .area_right .Notification {
    background:
        linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
    border-color: rgba(120, 210, 255, .22) !important;
}
</style>
